import './components/kit/vendors/antd/themes/default.css' // default theme antd components
import './components/kit/vendors/antd/themes/dark.css' // dark theme antd components
import './global.scss' // app & third-party component styles
// import './global.scss' // app & third-party component styles

import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
// import { logger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Router from './router'
import * as serviceWorker from './serviceWorker'
// import Auth0Provider from "./contexts/auth0-context";
import {Auth0Provider} from "@auth0/auth0-react";
import {AUTH_CONFIG} from "./constants/Config";

// middlewared
const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)


ReactDOM.render(
  <Provider store={store}>
    <Auth0Provider domain={AUTH_CONFIG.domain}
                   clientId={AUTH_CONFIG.clientId}
                   audience={AUTH_CONFIG.audience}
                   redirectUri={window.location.origin}
                   cacheLocation="localstorage"
                   >
      <Router history={history} />
    </Auth0Provider>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
